<template>
  <v-inventory-view
    name="transfer"
    title="transfer_orders"
    large
    to="/inventory/transfer"
    v-bind:headers="headers"
  >
    <template #header="{ data }">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{
            data.p_order
          }}</v-list-item-title>
          <v-list-item-subtitle>{{ $t(data.status) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          <span class="subtitle-2">{{ $t("date") }}:</span>
          <span class="body-2">{{ new Date(data.date).toDateString() }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-title>
          <span class="subtitle-2">{{ $t("ordered_by") }}:</span>
          <span class="body-2">{{ data.ordered_by_name }}</span>
        </v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{ $t("source_store") }}:</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="body-2">{{ data.first_service_name }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{ $t("destination_store") }}:</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="body-2">{{ data.second_service_name }}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-inventory-view>
</template>
<script>
export default {
  name: "InventoryTransferView",
  data: () => ({
    headers: [
      { text: "Item", value: "name" },
      { text: "Quantity", value: "quality", align: "right" },
    ],
  }),
  mounted() {
    this.headers = [
      { text: this.$t("sku"), value: "sku" },
      { text: this.$t("item"), value: "name" },
      { text: this.$t("barcode"), value: "barcode" },
      {
        text: this.$t("quantity"),
        value: "quality",
        align: "right",
        width: 120,
      },
      { text: this.$t("price"), value: "price", align: "right", width: 120 },
    ];
  },
};
</script>
